import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
} from '@appblocks/codegeneration/types';

export default class NodeParameter extends BaseFeature {
    constructor() {
        super();
        this.name = 'Node Parameter';
        this.id = 'node_parameter';

        const settings: Setting[] = [
            {
                id: 'NAME',
                name: 'Parameter Name',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'DATATYPE',
                name: 'Data Type',
                settingType: SettingType.OPTION,
                required: true,
                default: '',
                options: [
                    {
                        name: 'Byte',
                        value: 'byte',
                    },
                    {
                        name: 'Integer',
                        value: 'integer',
                    },
                    {
                        name: 'Short',
                        value: 'short',
                    },
                    {
                        name: 'Word',
                        value: 'word',
                    },
                    {
                        name: 'Long',
                        value: 'long',
                    },
                    {
                        name: 'DWord',
                        value: 'dword',
                    },
                    {
                        name: 'Real',
                        value: 'real',
                    },
                    {
                        name: 'Float',
                        value: 'float',
                    },
                    {
                        name: 'String',
                        value: 'string',
                    },
                    {
                        name: 'Boolean',
                        value: 'boolean',
                    },
                    {
                        name: 'Custom',
                        value: 'custom',
                    },
                ],
            },
            {
                id: 'DEFAULT',
                name: 'Default',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
